export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/dbn_renderer_worker.d71458f1.worker.js");
}
